// Single source of truth for the user-facing dashboard version.
// Shown permanently next to the header title, and announced by VersionBanner.
export const APP_VERSION = '1.8.50';
